import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing:border-box;
    line-height: 130%;
  }

  body{
    margin: 0;
    padding: 0;
    font-family: Avenir, Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, 'Helvetica Neue', 'Segoe UI', 'Apple SD Gothic Neo', 'Noto Sans KR', 'Malgun Gothic', sans-serif;
    font-size:16px;
    line-height: 130%;
    color: #ffffff;
    background: #171717;
  
    a {
      text-decoration: none;
      color:inherit;
    }
  
    h1,h2,h3,h4 {
      display: block;
    }
  }

  iframe {
    border: none;
  }

  .ball {
    position: fixed;
    border-radius: 100%;
    opacity: 0.6;
  }

  button {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
  }
`;

export default GlobalStyle;
